import { SxProps, Theme, Box } from "@mui/material";
import Grid from "@mui/system/Grid";
//
import PageTest from "./pageTest";
import Reference from "./Reference";
import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
//import { SxProps } from "@mui/material";

export default function ConnectedPage() {
    const sx: SxProps<Theme> = {
        borderRadius: 10,
        padding: "9px 10px",
        border: "1px solid rgba(31,41,55,0.8)",
        transition:
            "transform 0.08s ease-out, box-shadow 0.08s ease-out, border-color 0.08s ease-out, background 0.08s ease-out",
    };
    return (
        <Container>
            <p>This is home ! ! !</p>
            <Grid container spacing={5}>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byDate"}>
                        By Date
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"page/view/114"}>
                        Pages View
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/"}>
                        Tickets
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byDelTag/pro"}>
                        pro
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"filter/view/1"}>
                        search
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byDelTag/priv"}>
                        priv
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byDelTag/protos"}>
                        protos
                    </Box>
                </Grid>
                {/* line */}
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byDelTag/fin"}>
                        fin
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byDelTag/fdoe"}>
                        fdoe
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"session/debug"}>
                        sess/dbug
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"page/view/107"}>
                        Inbox
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byContext/1"}>
                        Home
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byContext/2"}>
                        Office
                    </Box>
                </Grid>
                {/* line */}
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byContext/3"}>
                        Outside
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byContext/4"}>
                        Computer
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byContext/5"}>
                        Hermine
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byContext/6"}>
                        Contacts
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byContext/7"}>
                        Offcom
                    </Box>
                </Grid>
                <Grid size={{ xs: 4, md: 2 }}>
                    <Box component={Link} sx={sx} to={"ticket/byContext/8"}>
                        Everywhere
                    </Box>
                </Grid>
            </Grid>
            <br />
            <br />
            <Link to={"debug/style"}>debug/Style</Link> . - .
            <Link to={"page/"}>Pages</Link> . - . . - .
            <Link to={"page/list"}>Pages List</Link> . - .
            <Link to={"auth/authorized"}>auth/authorized</Link> . - .
            <Link to={"auth/new-user-form"}>auth/new-user-form</Link> . - .
            <br />
            <br />
            <Link to={"page/edit/"}>new page</Link> . - .
            <br />
            <br />
            <br />
            <br />
            <Reference />
            <PageTest words={2} para={4} />
            <PageTest words={2} para={4} />
            <PageTest words={2} para={4} />
            <PageTest words={2} para={4} />
            <PageTest words={2} para={4} />
        </Container>
    );
}
